import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import ReCAPTCHA from "react-google-recaptcha";

import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import Mail from '@material-ui/icons/MailOutline';
import Error from '@material-ui/icons/Error';

import * as actions from '../../../actions/sts.actions';
import Loading from '../../dialogs/loading';

import urlSTSLogo from './images/logotipo-iflares-transparencia-sanitaria.svg'
import urlIflaresLogo from './images/iflares_Logo_LUZ.png'

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sts: undefined,
            stars: 0,
            message: '',
            captcha: undefined,
            thanks: undefined,
            error: false
        }
        this.props.load(this.props.id);
        this.myDivToFocus = React.createRef()
    }

    static getDerivedStateFromProps(props, state) {
        const { sts } = props;
        if (sts !== state.sts) {
            state.sts = sts;
            return state;
        }
        return null;
    }

    handleMore = () => {
        if (this.myDivToFocus.current) {
            this.myDivToFocus.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }
    }

    handleOnClick = (event) => {
        const { stars, message, captcha } = this.state;
        this.props.send(
            this.props.id,
            stars,
            message,
            captcha
        ).then((result) => { 
            if(result) {
                this.setState({ thanks: result })
            } else {
                this.setState({ error: true })
            }
        })
    }

    handleChange = (event) => {
        this.setState({ message: event.target.value });
    }

    onChange = (value) => {
        this.setState({ captcha: value });
    }

    render() {
        const { stars, message, thanks, captcha, error } = this.state;
        const { /*intl,*/ sts, sts_is_loading } = this.props;
        return (
            <div className="bodylocal">
                {sts_is_loading && <Loading open opacity />}
                <section className="bannerLocal">
                    <div className="innerLocal  padding_top_48 padding_bottom_48 ">
                        <div className="padding_bottom_48 padding_top_24 ">
                            <img alt="logo" width="300" className="margin_bottom_48 margin_top_32" src={urlSTSLogo} />
                        </div>
                        <p className="padding_bottom_48 ">
                            Nos complace compartir nuestra excelencia en los procesos que realizamos para que todos estemos más seguros
                        </p>
                    </div>
                </section>
                <article ref={this.myDivToFocus} id="main" className="mainLocal center">
                    <button onClick={this.handleMore} className="buttonLocalMore hand">Saber más</button>
                    {(sts && sts.nombre) &&
                        <header className="special container">
                            {sts.logo &&
                                <img
                                    src={sts.logo}
                                    width={250}
                                    alt="Preview"
                                />
                            }
                            <h2>
                                {sts.nombre}
                            </h2>
                            <p dangerouslySetInnerHTML={{ __html: sts.stsInformacion }}>
                            </p>
                        </header>
                    }
                    <section className="container-fluid">
                        {(sts && sts.familias && sts.familias.length > 0) &&

                            sts.familias.map((family) =>

                                <div key={randomstring()} className="flex_flux_row margin_bottom_12">
                                    <section className="headerFamily c_white uppercase">
                                        {
                                            family.nombre
                                        }
                                    </section>
                                    {
                                        family.procesos.map((proceso) =>
                                            <div key={randomstring()} className="flex_flux_row">
                                                <section className="headerProcess c_white ">
                                                    <div className="flex_full_row uppercase">
                                                        {proceso.nombre}
                                                    </div>
                                                    <div className="flex_auto_row nowrap periodo">
                                                        {proceso.periodo}
                                                    </div>
                                                </section>
                                                <div className="flex_full_row wrap">
                                                    {
                                                        proceso.instancias.map((instancia) =>
                                                            <div key={randomstring()} className="chip">
                                                                {instancia.creado}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                    </section>
                    {(sts.stsEncuesta && error) &&
                        <section className="wrapper style3 container special ">
                            <header className="major uppercase padding_borders center flex_full_column">
                                <Error className="mail" />
                                <h3 className=" padding_bottom_12" >Error</h3>
                                <p className="padding_bottom_48">Lo siento hemos tenido un error almacenado tu comentario</p>
                            </header>
                        </section>
                    }
                    {(sts.stsEncuesta && thanks) &&
                        <section className="wrapper style3 container special ">
                            <header className="major uppercase padding_borders center flex_full_column">
                                <Mail className="mail" />
                                <h3 className=" padding_bottom_12" >¡¡Gracias!!</h3>
                                <p className="padding_bottom_48">Tus comentarios nos ayudaran a mejorar</p>
                            </header>
                        </section>
                    }
                    {(sts.stsEncuesta && !thanks && !error) &&
                        <section className="wrapper style3 container special ">

                            <div className="row center">
                                <header className="major uppercase">
                                    <h3>Queremos saber tu opinión</h3>
                                </header>
                            </div>
                            <div className="row center">
                                {stars >= 1
                                    ? <Star onClick={() => { this.setState({ stars: 1 }) }} className={"c_bluish margin_right_12 margin_left_12 hand"} />
                                    : <StarBorder onClick={() => { this.setState({ stars: 1 }) }} className={"c_disabled margin_right_12 margin_left_12  hand"} />
                                }
                                {stars >= 2
                                    ? <Star onClick={() => { this.setState({ stars: 2 }) }} className={"c_bluish margin_right_12 margin_left_12  hand"} />
                                    : <StarBorder onClick={() => { this.setState({ stars: 2 }) }} className={"c_disabled margin_right_12 margin_left_12  hand"} />
                                }
                                {stars >= 3
                                    ? <Star onClick={() => { this.setState({ stars: 3 }) }} className={"c_bluish margin_right_12 margin_left_12  hand"} />
                                    : <StarBorder onClick={() => { this.setState({ stars: 3 }) }} className={"c_disabled margin_right_12 margin_left_12  hand"} />
                                }
                                {stars >= 4
                                    ? <Star onClick={() => { this.setState({ stars: 4 }) }} className={"c_bluish margin_right_12 margin_left_12  hand"} />
                                    : <StarBorder onClick={() => { this.setState({ stars: 4 }) }} className={"c_disabled margin_right_12 margin_left_12  hand"} />
                                }
                                {stars >= 5
                                    ? <Star onClick={() => { this.setState({ stars: 5 }) }} className={"c_bluish margin_right_12 margin_left_12  hand"} />
                                    : <StarBorder onClick={() => { this.setState({ stars: 5 }) }} className={"c_disabled margin_right_12 margin_left_12  hand"} />
                                }
                            </div>
                            <div className="row center margin_top_24">
                                <textarea
                                    name="message"
                                    onChange={this.handleChange}
                                    defaultValue={message}
                                />
                            </div>
                            <div className="row elements_from_right margin_top_24">
                                <ReCAPTCHA
                                    sitekey="6LcR1-cUAAAAANIZEYotXD31Z3lGfwXI0H3UAkDe"
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="row center margin_top_24">
                                <button
                                    disabled={!captcha || stars === 0}
                                    onClick={this.handleOnClick}
                                    className="flex_full_row center buttonLocalMore hand">Enviar</button>
                            </div>

                        </section>
                    }
                    <div className="cta">
                        <header>
                            <h3 className="uppercase">Muchas gracias por colaborar con nosotros</h3>
                            <p>Tu ayuda en mantener la limpieza y la sanidad en nuestro establecimiento es fundamental</p>
                        </header>
                    </div>
                </article>
                <footer className="footerLocal">
                    <div className="padding_bottom_48 padding_top_24 ">
                        <img alt="logo" width="96" src={urlIflaresLogo} />
                    </div>
                    <span className="copyright">iFlares Visual Management © 2020</span>
                </footer>
            </div>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired
};

function mapStateToProps(state) {
    return {
        sts: state.sts,
        sts_is_loading: state.sts_is_loading,
        sts_has_errored: state.sts_has_errored
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/cleanlocal/index.js